export default "__VITE_ASSET__DucisHTe__"